<template>
  <card-groups class="_my-sm-40 _my-md-60">
    <card-box>
      <card-header>
        <btn-toggle v-b-toggle.accordion0 class="-plus">
          <h2 class="heading">撮影時のポイント</h2>
        </btn-toggle>
      </card-header>
      <collapse-item id="accordion0" accordion="accordion" visible="true">
        <card-body>
          <div class="point-box _mb-md-30">
            <div class="point-img _mb-sm-30 _pr-md-20">
              <p class="txt01 _mb-md-30"><img src="@/assets/images/icons/circle-orange.svg" class="img-fluid _mr-md-20" alt="">よい例</p>
              <img src="@/assets/images/en/en018/img01.jpg" class="img-fluid" alt="">
              <list-group class="-normal _mt-15">
                <list-item class="-normal">文字がはっきり読める</list-item>
                <list-item class="-normal">書類全体が写っている</list-item>
              </list-group>
            </div>
            <div class="point-img _pl-md-20">
              <p class="txt01 _mb-md-30"><img src="@/assets/images/icons/close-gray.svg" class="img-fluid _mr-md-20" alt="">悪い例</p>
              <img src="@/assets/images/en/en018/img02.jpg" class="img-fluid" alt="">
              <list-group class="-normal _mt-15">
                <list-item class="-normal">画像がぼやけている</list-item>
                <list-item class="-normal">写真が切れている</list-item>
              </list-group>
            </div>
          </div>
          <list-group class="-note">
            <list-item class="-note">画像はイメージになります。</list-item>
            <list-item class="-note">画像に不備がある場合、お電話を差しあげることがございます。</list-item>
          </list-group>
        </card-body>
      </collapse-item>
    </card-box>
  </card-groups>
</template>

<script>
import CollapseItem from '../collapse/CollapseItem'
import CardBody from '../card/CardBody'
import HeadingThree from '../heading/HeadingThree'
import ListGroup from '../list/ListGroup'
import ListItem from '../list/ListItem'
import CardGroups from '../card/CardGroups'
import CardBox from '../card/CardBox'
import CardHeader from '../card/CardHeader'
import BtnToggle from '../button/BtnToggle'

export default {
  name: 'income-point',
  components: {
    BtnToggle,
    CardHeader,
    CardBox,
    CardGroups,
    ListItem,
    ListGroup,
    HeadingThree,
    CardBody,
    CollapseItem
  }
}
</script>

<style lang="scss" scoped>
  @import "../../assets/stylesheets/styles";

  .point-box {
    display: flex;
    flex-wrap: wrap;
    >.point-img {
      width: 100%;
      @include mq-up(md) {
        width: 50%;
      }
      >.txt01 {
        width: 100%;
        display: flex;
        align-items: center;
        font-weight: bold;
        img {
          width: 20px;
          @include mq-up(md) {
            width: 30px;
          }
        }
      }
      img {
        width: 50%;
        @include mq-down(md) {
          /*width: calc(50% - 2px);*/
          width: 100%;
        }
        @include mq-up(md) {
          /*max-width: 287px;*/
          width: 100%;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/upload/IncomePoint.vue